import { MenuItem, Select } from '@material-ui/core'

interface IFilterTypeProps {
    filterName: string,
    onChange: (e) => void,
    value: string,
    setValue: (e) => void
}
const textSearchFilterTypes = [{ name: 'Contains', value: 'contains' }];
const dateSearchFilterTypes = [{ name: 'Is', value: 'is' }, { name: 'Is on or after', value: 'isonorafter' }, { name: 'Is on or before', value: 'onOrBefore' }];

const FilterType = ({ filterName = '', onChange, value, setValue }: IFilterTypeProps) => {
    const filterTypeList = filterName === 'DATE/TIMESTAMP' ? dateSearchFilterTypes : textSearchFilterTypes;
    const handleChange = (e) => {
        setValue(e.target.value);
        onChange(e.target.value)
    }
    return (
        <Select
            variant='standard'
            value={value}
            style={{
                marginRight: 16,
                minWidth: '60px'
            }}
            onChange={handleChange}
        >
            {filterTypeList.map(({ name, value }, i) =>
                <MenuItem key={i} value={value}>{name}</MenuItem>)}
        </Select>
    )
}

export default FilterType